<section class="container custom-tooltip" (mouseleave)="tt.close()">
  <button
    type="button"
    class="accessible-tooltip-trigger ico ico-info-circle"
    i18n-ngbTooltip
    triggers="manual"
    (mouseenter)="tt.open()"
    (focus)="tt.open()"
    (blur)="tt.close()"
    (click)="tt.toggle()"
    #tt="ngbTooltip"
    [attr.aria-label]="ariaLabel || 'More information'"
    [ngbTooltip]="tooltipContent"
  >
    <ng-template #tooltipContent>
      <div class="tooltiptext" [innerHTML]="tooltipText"></div>
    </ng-template>
    <span class="visuallyhidden">{{ ariaLabel || 'More information' }}</span>
  </button>
</section>
